"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalPage_1 = require("./ModalPage");
exports.ModalPage = ModalPage_1.ModalPage;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ModalPage/index.ts
// module id = 697
// module chunks = 0